module.exports = __webpack_public_path__ + "static/media/custom-video-player.01400cb0.png";